var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgVisibilityOn = function SvgVisibilityOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75a1.75 1.75 0 010 3.5 1.75 1.75 0 010-3.5zm3.25 1.75a3.25 3.25 0 00-6.5 0 3.25 3.25 0 006.5 0zm-13.44 0C3.5 7.532 7.425 4.75 12 4.75c4.576 0 8.501 2.782 10.19 6.75-1.689 3.968-5.614 6.75-10.19 6.75-4.575 0-8.501-2.782-10.19-6.75z",
    stroke: "#222",
    strokeWidth: 1.5
  })));
};
export default SvgVisibilityOn;